import React from 'react';
import { Bell } from 'lucide-react';
import { Button } from '../ui/button';

export const Header = ({ title, subtitle, actions }) => {
    return (
        <header
            className="px-8 py-4 border-b"
            style={{ background: '#FDF6F0', borderColor: '#E8D0BC' }}
            data-testid="page-header"
        >
            <div className="flex items-center justify-between">
                <div>
                    <h1
                        className="text-2xl font-bold font-heading"
                        style={{ color: '#2D0C10' }}
                        data-testid="page-title"
                    >
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="text-sm mt-1" style={{ color: '#A0462D' }} data-testid="page-subtitle">
                            {subtitle}
                        </p>
                    )}
                </div>
                <div className="flex items-center gap-4">
                    {actions}
                    <Button variant="ghost" size="icon" className="relative" data-testid="notifications-btn">
                        <Bell className="w-5 h-5" style={{ color: '#A0462D' }} />
                        <span className="absolute top-1 right-1 w-2 h-2 rounded-full" style={{ background: '#A0462D' }} />
                    </Button>
                </div>
            </div>
        </header>
    );
};

export default Header;
